module.exports = __webpack_public_path__ + "img/background06.95e4d2df.png";